var COOKIE_SG_LANGUAGE = "sgwt_language";
var COOKIE_SG_DESIGN_SYSTEM_THEME = "sgwt_sg-design-system_theme";
/**
 * This class provides some useful functions to get context information for the Service.
 * The context information (the language or the SG Design System theme) can be accessed by the application really early
 * - before the Bus gets the information (as they are filled by others widgets that need some time to load) - and then
 * can be used to bootstrap the Service with the right information.
 */
var WidgetContext = /** @class */ (function () {
    function WidgetContext() {
    }
    WidgetContext.prototype.readCookie = function (name) {
        var _a;
        return (((_a = document.cookie
            .split("; ")
            .find(function (row) { return row.startsWith(name + "="); })) === null || _a === void 0 ? void 0 : _a.split("=")[1]) || null);
    };
    WidgetContext.prototype.writeCookie = function (name, value) {
        var date = new Date();
        date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
        var expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    };
    /**
     * Get the language for the service ('en', 'fr', etc.).
     * It can be `null` if the language is not known.
     * ! Call this function during the application bootstrap, before the Bus can be filled with the corresponding information.
     * @returns The language for the Service or `null` if unknown.
     */
    WidgetContext.prototype.getLanguage = function () {
        return this.readCookie(COOKIE_SG_LANGUAGE);
    };
    /**
     * Set the cookie for the language of the Service.
     * ! This function is normally only called by the SGWT Account Center.
     * @param language The new language to set.
     */
    WidgetContext.prototype.setLanguage = function (language) {
        this.writeCookie(COOKIE_SG_LANGUAGE, language.toLowerCase());
    };
    /**
     * Get the SG Design System theme.
     * When the SG Design System theme is set to adapt to the user system (theme = 'system'), this function returns either
     * 'standard' or 'dark' depending on the user system theme, and **not** 'system'.
     * ! Call this function during the application bootstrap, before the Bus can be filled with the corresponding information.
     * @returns SG Design System theme ('standard', 'dark', 'system') to use for the Service or `null` if unknown.
     */
    WidgetContext.prototype.getSgDesignSystemTheme = function () {
        var theme = this.readCookie(COOKIE_SG_DESIGN_SYSTEM_THEME);
        if (theme === "system") {
            var isSystemOnDarkTheme = window.matchMedia &&
                window.matchMedia("(prefers-color-scheme: dark)").matches;
            return isSystemOnDarkTheme ? "dark" : "standard";
        }
        if (theme === "standard" || theme === "dark") {
            return theme;
        }
        return null;
    };
    /**
     * Set the theme used by the Service.
     * ! This function is normally only called by the SGWT Account Center.
     * @param theme Theme to use for the Service, either 'standard', 'dark', 'system'
     */
    WidgetContext.prototype.setSgDesignSystemTheme = function (theme) {
        this.writeCookie(COOKIE_SG_DESIGN_SYSTEM_THEME, theme);
    };
    return WidgetContext;
}());
export { WidgetContext };
